import { t } from '@ankr.com/common';

import { ChargingModelType } from 'modules/billing/types';

export const getLabel = (
  hasPremiumLabel: boolean,
  chargingModelType?: ChargingModelType,
): string => {
  if (chargingModelType) {
    if (chargingModelType === 'package') {
      return t('account.charging-model.package.title');
    }

    if (chargingModelType === 'deal') {
      return t('account.charging-model.deal.title');
    }

    if (chargingModelType === 'payg') {
      return t('account.charging-model.payg.title');
    }
  }

  if (hasPremiumLabel) return t('chains.user-premium');

  return t('chains.user-free');
};
